<template>
	<v-dialog v-model="dialog" :max-width="maxWidth" v-bind="$attrs" :persistent="persistent">
		<div
			class="relative bg-white rounded d-flex flex-column justify-center"
			:class="[className]">
			<div class="absolute" style="right: -0.5rem; top: -0.5rem" v-if="closeBtn">
				<v-btn density="comfortable" icon color="red lighten-2" @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>

			<div class="text-center" v-if="logo">
				<v-img
					:src="assetsUrl('img/logo.png')"
					class="mx-auto mb-4"
					style="margin-top: -60px"
					:width="80"
					:height="80" />
			</div>

			<div class="px-4 d-flex justify-center">
				<div>
					<div v-for="(val, key) in txts" :key="key" class="mb-2 text-center">
						{{ val }}
					</div>
				</div>
			</div>

			<div class="text-center mt-4" v-if="confirmBtn">
				<v-btn
					class="text-white"
					color="primary"
					elevation="0"
					@click="close()"
					style="min-width: 120px">
					Ok
				</v-btn>
			</div>
		</div>
	</v-dialog>
</template>
<script>
export default {
	props: {
		modelValue: {},
		className: {
			type: String,
			default: 'pa-5',
		},
		maxWidth: {
			type: Number,
			default: 500,
		},
		persistent: {
			type: Boolean,
			default: false,
		},
		closeBtn: {
			type: Boolean,
			default: false,
		},
		confirmBtn: {
			type: Boolean,
			default: true,
		},
		logo: {
			type: Boolean,
			default: true,
		},
		txts: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		dialog: {
			get() {
				return this.modelValue;
			},
			set(val) {
				this.$emit('update:modelValue', val);
			},
		},
	},
	methods: {
		open() {
			this.dialog = true;
		},
		close() {
			this.dialog = false;
			this.$emit('onClose');
		},
	},
};
</script>
<style lang="scss" scoped>
.theme--light {
	.v-dialog {
		.v-card {
			background-color: #f8f8f8 !important;
		}
	}
}
.absolute {
	position: absolute;
}
.relative {
	position: relative;
}
.right-0 {
	right: 0;
}
</style>
